import React from 'react'
import { Header } from '../../ProjectListing/Sidebar/Header'
import { observer } from 'mobx-react'
import chosenProjectStore from '../../../Store/ChosenProject'
import { BtSidebar } from '@linqpal/components/src/ui'
import { ViewForm } from '../ViewForm'
import { FooterEditSidebar } from '../FooterEditSidebar'
import { useTranslation } from 'react-i18next'
import { paths } from '../../../../links'
import { useNavigation } from '@react-navigation/native'
import { PROJECT_SECTIONS } from '@linqpal/models/src/dictionaries'
import ProjectStore from '../../../../ProjectForm/Store'
import { mapToNewProjectModel } from '../../../mapToNewProjectModel'
import { Form } from '@linqpal/models/src/mst/Form'

export const ViewProjectSidebar = observer(({ chosenProject }): JSX.Element => {
  const { t } = useTranslation('global')
  const { isOpenedSidebar, setSidebar } = chosenProjectStore
  const navigation = useNavigation()
  const { setFormData } = ProjectStore

  const closeSidebar = () => {
    setSidebar(false)
  }

  const onEdit = () => {
    if (chosenProject.data)
      setFormData({
        data: chosenProject.data,
        currentSection: PROJECT_SECTIONS.ADDRESS,
      })
    else {
      const data = mapToNewProjectModel(
        chosenProject.address,
        chosenProject.contractValue,
      )
      setFormData(
        Form.create({
          data,
          currentSection: PROJECT_SECTIONS.ADDRESS,
        }),
      )
    }
    navigation.navigate(paths.NewProject, { projectId: chosenProject._id })
    closeSidebar()
  }

  return (
    <BtSidebar
      visible={isOpenedSidebar}
      onClose={() => {
        closeSidebar()
        return null
      }}
      width={584}
      title={
        <Header
          closeSidebar={closeSidebar}
          title={t('Projects.projectDetails')}
        />
      }
      customPadding={32}
      divider={false}
      footer={<FooterEditSidebar onEdit={onEdit} />}
    >
      <ViewForm chosenProject={chosenProject} />
    </BtSidebar>
  )
})
